import React from 'react'
import classNames from 'classnames';

function InlineRow({children,className}) {

  return (
    <div className={classNames(
      "cge-inline-row", className)} >
      {children}
    </div>
  )

}

function InlineCol({children}) {

  return (
    <div className="cge-inline-col">
      {children}
    </div>
  )

}


export { InlineRow, InlineCol }